import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppRooute } from 'src/app/core/common/app-route.model';
import { AppSettings } from 'src/app/core/common/app-settings';
import { RouteConstant } from 'src/app/core/common/route-constant';
import { StateConstant } from 'src/app/core/common/state-constant';
import { OperacionEnum } from 'src/app/core/enums/operacion.enum';
import { TypeOperationEnum } from 'src/app/core/enums/type-operation.enum';
import { GrupoSocioService } from 'src/app/core/services/caso/grupo-socio.service';
import { GrupoService } from 'src/app/core/services/caso/grupo.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { GrupoDto } from 'src/app/shared/models/caso/grupo/grupo-dto.model';
import { GrupoSocioVo } from 'src/app/shared/models/caso/grupo/grupo-socio/grupo-socio-vo.model';
import { GrupoSocioFormComponent } from '../grupo-socio/grupo-socio-form/grupo-socio-form.component';

@Component({
  selector: 'vex-grupo-form',
  templateUrl: './grupo-form.component.html',
  styleUrls: ['./grupo-form.component.scss']
})
export class GrupoFormComponent implements OnInit {
  appSettings = AppSettings;
  stateConstant = StateConstant;
  crumbs: AppRooute[] = [RouteConstant.ROUTE_CASE_GRUPO];

  form: FormGroup;
  id: number;
  actionType: string;

  grupoService = inject(GrupoService);
  grupoSocioService = inject(GrupoSocioService);

  dataSource: MatTableDataSource<GrupoSocioVo>;
  displayedColumns: string[] = ['razonSocial', 'contacto', 'email', 'celular', 'fechaRegistro', 'usuarioRegistro', 'actions'];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  selection = new SelectionModel<GrupoSocioVo>(true, []);
  searchKey: string;

  dto: GrupoDto = new GrupoDto();
  formLabel: string = "Nuevo grupo";

  constructor(private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private dialog: MatDialog,
    private fb: FormBuilder) {

    this.form = this.fb.group({
      nombre: ["", Validators.required],
      activo: [true, Validators.required],
      alerta: [true, Validators.required],
      whatsapp: [true, Validators.required],
      sms: [false, Validators.required],
      push: [false, Validators.required],
      email: [false, Validators.required]
    });
  }

  ngOnInit(): void {
    this.actionType = this.route.snapshot.params.actionType;
    if (this.actionType === TypeOperationEnum.UPDATE) {
      this.formLabel = "Datos del grupo";
      this.id = this.route.snapshot.params.id;
      this.grupoService.findById(this.id)
        .subscribe(
          response => {
            this.form.controls['nombre'].setValue(response.data.nombre);
            this.form.controls['activo'].setValue(response.data.activo);
            this.form.controls['alerta'].setValue(response.data.alerta);
            this.form.controls['whatsapp'].setValue(response.data.whatsapp);
            this.form.controls['sms'].setValue(response.data.sms);
            this.form.controls['push'].setValue(response.data.push);
            this.form.controls['email'].setValue(response.data.email);
          },
          err => {
            console.error('Código del error desde el backend: ' + err.status);
            console.error(err.error.errors);
          }
        );
      this.loadSocios();
    }
  }

  loadSocios(): void {
    this.grupoSocioService.findAll(this.id).subscribe(
      response => {
        this.dataSource = new MatTableDataSource(response.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      },
      err => {
        console.error(err);
      }
    );
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  save() {
    this.dto.nombre = this.form.value.nombre;
    this.dto.activo = this.form.value.activo;
    this.dto.alerta = this.form.value.alerta;
    this.dto.whatsapp = this.form.value.whatsapp;
    this.dto.sms = this.form.value.sms;
    this.dto.push = this.form.value.push;
    this.dto.email = this.form.value.email;

    switch (this.actionType) {
      case TypeOperationEnum.CREATE: {
        this.grupoService.persist(this.dto).subscribe(response => {
          if (response.status) {
            this.toastrService.success(response.message);
            this.router.navigate([`./${RouteConstant.ROUTE_CASE_GRUPO.url}`]);
          } else
            this.toastrService.warning(response.message);
        });
        break;
      }
      case TypeOperationEnum.UPDATE: {
        this.grupoService.update(this.id, this.dto).subscribe(response => {
          if (response.status) {
            this.toastrService.success(response.message);
            this.router.navigate([`./${RouteConstant.ROUTE_CASE_GRUPO.url}`]);
          } else
            this.toastrService.warning(response.message);
        });
        break;
      }
    }
  }

  agreeGrupoSocio() {
    const dialogRef = this.dialog.open(GrupoSocioFormComponent, {
      width: AppSettings.DIALOG_WIDTH,
      data: {
        operation: OperacionEnum.create,
        title: 'Agregar socio',
        button: AppSettings.DIALOG_BUTTON_PERSIST_POSITIVE,
        entity: this.id
      }
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.loadSocios();
      }
    });
  }

  deleteGrupoSocio(vo: GrupoSocioVo) {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: new ConfirmDialogModel("Quitar socio de grupo", "¿Está seguro de remover el socio del grupo?")
      })
      .afterClosed()
      .subscribe((confirmado: Boolean) => {
        if (confirmado) {
          this.grupoSocioService.delete(this.id, vo.id).subscribe(
            response => {
              if (response.status) {
                this.toastrService.success(response.message);
                this.loadSocios();
              } else {
                this.toastrService.warning(response.message);
              }
            },
            err => {
              this.toastrService.error(err.data);
            }
          )
        }
      });
  }

}
